// Dernière phase de cycle connue, mémorisée en local.
//
// Raison d'être : la carte « Astuce du jour » de l'accueil doit s'afficher dès le
// premier rendu. Attendre le résumé dashboard la ferait apparaître après coup et
// pousserait le camembert vers le bas. La phase doit donc être lisible synchronement,
// d'où cette mémoire ; le résumé, une fois arrivé, prend le relais.
//
// Elle est écrite par les deux pages qui résolvent déjà la phase depuis le résumé
// dashboard (`pages/Home.js` et `pages/Blog.js`).
//
// Ce n'est qu'un confort d'affichage : `tipOfTheDay` (`constants/phaseTips.js`) sait
// puiser dans les 60 astuces quand la mémoire est vide. Rien ne dépend de sa présence.
import { PHASE_TIP_KEYS } from '../constants/phaseTips';

const CLE = 'cyclegala_last_known_phase';

/**
 * Mémorise la phase, à condition que ce soit une clé du vocabulaire moteur
 * (`REGLES`, `FOLLICULAIRE`, `OVULATION`, `LUTEALE`). Le filtre n'est pas
 * cosmétique : l'app fait coexister quatre vocabulaires de phase, et mémoriser un
 * libellé français ou un slug CSS reviendrait à empoisonner silencieusement la
 * mémoire avec une valeur qu'aucune table d'astuces ne reconnaît.
 */
export function rememberPhase(key) {
  if (!PHASE_TIP_KEYS.includes(key)) return;
  try {
    localStorage.setItem(CLE, key);
  } catch (_) {
    // Navigation privée, stockage bloqué ou quota plein : on perd le confort, pas
    // l'affichage — le repli toutes-phases prend le relais.
  }
}

/** La phase mémorisée, ou `null`. Ne lève jamais. */
export function recallPhase() {
  try {
    const brut = localStorage.getItem(CLE);
    // Une valeur écrite par une version antérieure du format ne doit pas ressortir
    // telle quelle : on la revalide à la lecture autant qu'à l'écriture.
    return PHASE_TIP_KEYS.includes(brut) ? brut : null;
  } catch (_) {
    return null;
  }
}
